'use strict';

import Marionette from 'backbone.marionette';
import DialogService from 'base/dialog_service';


const ImageView = Marionette.LayoutView.extend({
  template: require('../templates/image-view.html'),
  tagName: 'li',

  ui: {
    buttonAccept: '.button-accept'
  },

  triggers: {
    'click @ui.buttonAccept': 'accept'
  },

  templateHelpers(){
    return {
      mode: this.options.mode
    };
  }
});


const NoImageView = Marionette.LayoutView.extend({
  template: require('../templates/image-none.html')
});


const ImageListView = Marionette.CompositeView.extend({
  template: require('../templates/image-list.html'),
  childView: ImageView,
  childViewContainer: '.imageList',
  emptyView: NoImageView,

  ui: {
    addImage: '.button-add-image'
  },

  triggers: {
    'click @ui.addImage': 'addImage'
  },

  childViewOptions(){
    return {
      mode: this.options.mode
    };
  },

  onChildviewAccept(child){
    this.model.set('icon', child.model.get('key'));
    this.closeModal();
  },

  closeModal(){
    this.trigger('finish');
  },

  onAddImage(){
    if(this.options.mode == 'display'){
      let c = new ImagePickView({
        model: this.model,
        collection: this.collection
      });

      let m = DialogService.show(c);

      c.on('finish', () => {
        m.trigger('close');
      });
      m.showChildView('content', c);

      m.on('close', () => {
        m.close();
        this.render();
      });
    }
  },

  filter(child){
    let key = child.get('key');
    if(this.options.mode == 'display'){
      if(this.model.get('icon') == key){
        return true;
      }
      return false;
    } else{
      return true;
    }
  },

  childEvents: {
    remove: 'onChildRemove'
  },

  templateHelpers(){
    return {
      mode: this.options.mode
    };
  },

  onChildRemove(childView){
    if(confirm('Are you sure? (Note: this does not delete it from the system)')){
      this.collection.remove(childView.model);
      this.render();
    }
  }
});

const ImagePickView = Marionette.LayoutView.extend({
  template: require('../templates/image-dialog.html'),
  regions: {
    image: '.image-hook'
  },

  ui: {
    closeButton: '.close-button'
  },
  triggers: {
    'click @ui.closeButton': 'close'
  },

  onRender(){
    let view = new ImageListView({
      model: this.model,
      collection: this.collection,
      mode: 'pick'
    });
    this.listenTo(view, 'finish', () => {
      this.closeModal();
    });
    this.showChildView('image', view);
  },

  onClose(){
    this.closeModal();
  },

  closeModal(){
    this.trigger('finish');
  }
});

export default ImageListView;



// WEBPACK FOOTER //
// ./offers/views/images.js